export var ESenderType = /*#__PURE__*/function (ESenderType) {
  ESenderType["Sms"] = "sms";
  ESenderType["Call"] = "call";
  return ESenderType;
}({});
export var ESendCodeStatus = /*#__PURE__*/function (ESendCodeStatus) {
  ESendCodeStatus["Succeed"] = "succeed";
  ESendCodeStatus["Failed"] = "failed";
  return ESendCodeStatus;
}({});